// src/components/ui/Infobulle.js
import React, { useState } from 'react';
import { Info, AlertTriangle, CheckCircle, X } from 'lucide-react';

const TYPES = {
  info: {
    icon: Info,
    bg: 'bg-blue-50 dark:bg-blue-950/30',
    text: 'text-blue-700 dark:text-blue-300',
    iconColor: 'text-blue-500 dark:text-blue-400',
  },
  warning: {
    icon: AlertTriangle,
    bg: 'bg-amber-50 dark:bg-amber-950/30',
    text: 'text-amber-700 dark:text-amber-300',
    iconColor: 'text-amber-500 dark:text-amber-400',
  },
  success: {
    icon: CheckCircle,
    bg: 'bg-emerald-50 dark:bg-emerald-950/30',
    text: 'text-emerald-700 dark:text-emerald-300',
    iconColor: 'text-emerald-500 dark:text-emerald-400',
  },
};

const Infobulle = ({ type = 'info', storageKey, children }) => {
  const [dismissed, setDismissed] = useState(
    () => storageKey && localStorage.getItem(storageKey) === 'true'
  );

  if (dismissed) return null;

  const t = TYPES[type] || TYPES.info;
  const Icon = t.icon;

  const handleDismiss = () => {
    if (storageKey) localStorage.setItem(storageKey, 'true');
    setDismissed(true);
  };

  return (
    <div className={`flex items-start gap-3 p-3 rounded-xl mb-4 ${t.bg}`}>
      <Icon size={18} className={`flex-shrink-0 mt-0.5 ${t.iconColor}`} />
      <p className={`flex-1 text-sm ${t.text}`}>{children}</p>
      {storageKey && (
        <button
          onClick={handleDismiss}
          className={`flex-shrink-0 ${t.iconColor} hover:opacity-70 transition-opacity`}
          aria-label="Fermer"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

export default Infobulle;
